var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single"},[_c('v-card',{staticClass:"mx-auto card mt-0 mb-0",attrs:{"flat":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }